module.exports = __webpack_public_path__ + "static/pets-80a87dd5cf2f6c71d1d4a08a3239de32.jpg";